module.exports = __webpack_public_path__ + "img/hr-sand-decal-14.d27f223e.png";